/**
 * "Step 2 of 3" — where the user is in the reset, stated in words (WCAG 2.4.8). A plain paragraph,
 * NOT a live region: each step moves focus to its own field on arrival, and announcing the counter
 * as well would read every transition twice.
 *
 * @module @puffin-core/login-shell/components/passwordReset/ResetStepIndicator
 */

import PropTypes from 'prop-types';

/**
 * @param {Object} props
 * @param {number} props.current - 1-based
 * @param {number} props.total
 * @param {Function} props.translate
 * @returns {React.JSX.Element}
 */
export function ResetStepIndicator({ current, total, translate }) {
  return (
    <p className="text text-xs text-muted mb-sm" data-testid="reset-step-indicator">
      {translate('modal.passwordReset.stepOf', { current, total })}
    </p>
  );
}

ResetStepIndicator.propTypes = {
  current: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  translate: PropTypes.func.isRequired,
};

export default ResetStepIndicator;
